const STALE_LRU_OPTIONS = {
  maxAge: process.env.STALE_LRU_MAX_AGE || 3,
  maxSize: process.env.STALE_LRU_MAX_SIZE || 1000,
  staleWhileRevalidate: process.env.STALE_LRU_STALE_WHILE_REVALIDATE || 60
}

const WARNING_THRESHOLD = 200 // milliseconds

let cache
let logger
if (__IS_SERVER__) {
  // The stale-lru-cache module is required here because it was not properly three-shaken away.
  // This may be an issue with our build config, but it might also be an issue with stale-lru-cache
  const StaleLRU = require('stale-lru-cache')
  cache = new StaleLRU(STALE_LRU_OPTIONS)
  logger = require('../../../scripts/lib/logger')
}

export function getFromCache<T>(
  url,
  fetchFn: (key: string) => Promise<T>,
  maxAge = STALE_LRU_OPTIONS.maxAge
): Promise<T> {
  if (cache) {
    async function revalidate(key, callback) {
      try {
        const startTime = Date.now()

        const data = await fetchFn(key)
        if (logger) {
          const duration = Date.now() - startTime
          if (duration > WARNING_THRESHOLD) {
            logger.warn(
              `Request over ${WARNING_THRESHOLD} ms. Fetched data in ${duration} ms for url ${url}`
            )
          } else {
            logger.info(`Fetched data in ${duration} ms for url ${url}`)
          }
        }
        callback(null, data, { maxAge })
      } catch (error) {
        logger.warn(`Failed while revalidating data for url ${url}`)
        callback(error)
      }
    }

    const cached = cache.get(url)
    if (cached) {
      if (logger) {
        logger.info(`Returning data from cache for url ${url}`)
      }
      return Promise.resolve(cached)
    } else {
      return new Promise((resolve, reject) => {
        cache.wrap(url, revalidate, (error, data) => {
          if (error) {
            reject(error)
          } else {
            resolve(data as T)
          }
        })
      })
    }
  }

  return fetchFn(url)
}
